import React from "react";

export interface HoverCardListItemProps {
    label: string;
    value: string | null;
}

export const HoverCardListItem: React.FC<HoverCardListItemProps> = ({ label, value }) => {
    if (!value) {
        return null;
    }

    return (
        <>
            <span className="fw-bold align-content-center border-top py-2 pe-3">{label}</span>
            <span className="text-break border-top py-2">{value}</span>
        </>
    );
};
